import { EmailPasswordForm } from "./EmailPasswordForm";
import { GoogleLoginForm } from "./GoogleLoginForm";

const SHOW_EMAIL_LOGIN = import.meta.env.FO_ENV !== "prod";

export const Login = () => {
  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <div className="w-full max-w-md space-y-6 p-8">
        {/* Render Google Login First */}
        <GoogleLoginForm />

        {/* Conditionally render Email Form with Divider */}
        {SHOW_EMAIL_LOGIN && (
          <>
            <div className="relative my-4">
              <div className="absolute inset-0 flex items-center">
                <span className="w-full border-t" />
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-background px-2 text-muted-foreground">
                  Or continue with
                </span>
              </div>
            </div>
            <EmailPasswordForm />
          </>
        )}
      </div>
    </div>
  );
};
